/* Shopify owns authentication. Let its native form submit normally; remember
   only the requested destination in this tab, never the password. */
(function () {
  'use strict';
  var key = 'reve:owner-return';
  var destination = '/pages/control?view=control';
  var path = window.location.pathname.replace(/\/$/, '') || '/';
  if (path !== '/password') {
    var pending = null;
    try {
      pending = window.sessionStorage.getItem(key);
      window.sessionStorage.removeItem(key);
    } catch (error) { return; }
    if (pending === destination && path !== '/pages/control') {
      window.location.replace(destination);
    }
    return;
  }
  // Returning here means the visitor is still at Shopify's password gate.
  // Clear any unsuccessful or abandoned attempt before binding a new one.
  try {
    window.sessionStorage.removeItem(key);
    window.sessionStorage.removeItem('reve:owner-pass');
  } catch (error) {}
  var input = document.getElementById('reve-owner-password');
  var form = input && input.closest('form');
  if (!form || form.dataset.reveNativeOwner === '1') return;
  form.dataset.reveNativeOwner = '1';
  form.addEventListener('submit', function () {
    try {
      window.sessionStorage.setItem(key, destination);
      window.sessionStorage.setItem('reve:owner-pass', input.value);
    } catch (error) {}
    // No preventDefault, no fetch: Shopify validates and sets its own cookies
    // through a regular browser navigation. A rejected password stays here.
  });
})();
